import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function AuthGuard({ children }) {
  const { isFullyAuthenticated, isAuth0Authenticated, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  // If authenticated with Auth0 but not with MFA, redirect to MFA page
  if (isAuth0Authenticated && !isFullyAuthenticated) {
    return <Navigate to="/mfa-verification" state={{ from: location }} replace />;
  }
  
  // If not authenticated at all, redirect to home
  if (!isAuth0Authenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  
  // If fully authenticated, render children
  return children;
}